// "component library projects" is basically a template with a special name.
// This is a different product that lives at an account level and allows account admins to distribute standardized content to projects throughout the org.
// We use this function in order to hide this “container” project from users.
export const isComponentLibraryProject = (name: string): boolean =>
  /^Component Library Project [\da-f]{8}-[\da-f]{4}-[0-5][\da-f]{3}-[089ab][\da-f]{3}-[\da-f]{12}$/.test(
    name,
  );
